/**
 * valumize API for managing funds
 * Lorem ipsum ...
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AiSetupResultStatus = 'PENDING_REVIEW' | 'ACCEPTED' | 'SKIPPED';

export const AiSetupResultStatus = {
    PendingReview: 'PENDING_REVIEW' as AiSetupResultStatus,
    Accepted: 'ACCEPTED' as AiSetupResultStatus,
    Skipped: 'SKIPPED' as AiSetupResultStatus
};

